import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@tsuyosa/auth';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Layout } from '@/components/Layout';
import { LoginPage }        from '@/pages/LoginPage';
import { RegisterPage }     from '@/pages/RegisterPage';
import { VerifyEmailPage }  from '@/pages/VerifyEmailPage';
import { DashboardPage }    from '@/pages/DashboardPage';
import { ProfilePage }      from '@/pages/ProfilePage';
import { MembersPage }      from '@/pages/MembersPage';
import { DiscographyPage }  from '@/pages/DiscographyPage';
import { OrderHistoryPage } from '@/pages/OrderHistoryPage';

const API_URL  = import.meta.env.VITE_API_URL ?? '';
const CHEKI_URL = import.meta.env.VITE_CHEKI_URL ?? 'https://cheki.tsuyosa.id';

function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return (
    <div className="flex min-h-screen items-center justify-center">
      <span className="text-white/40 text-sm">Mengalihkan...</span>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider apiUrl={API_URL}>
      <BrowserRouter>
        <Routes>
          <Route path="/login"        element={<LoginPage />} />
          <Route path="/register"     element={<RegisterPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />

          <Route path="/"            element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
          <Route path="/profile"     element={<ProtectedRoute><Layout><ProfilePage /></Layout></ProtectedRoute>} />
          <Route path="/members"     element={<ProtectedRoute><Layout><MembersPage /></Layout></ProtectedRoute>} />
          <Route path="/discography" element={<ProtectedRoute><Layout><DiscographyPage /></Layout></ProtectedRoute>} />
          <Route path="/cheki"       element={<ExternalRedirect to={CHEKI_URL} />} />
          <Route path="/orders"      element={<ProtectedRoute><Layout><OrderHistoryPage /></Layout></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
